import React, { useEffect, useState } from "react";
import { Button } from "@tvg/design-system";
import IPP from "@tvg/ipp";
import ApolloContext from "@tvg/utils/apolloContext";
import ApolloContextClients from "@tvg/utils/types/ApolloContext";
import useWagerProfile from "@tvg/custom-hooks/hooks/useWagerProfile";
import { events as AlchemerEvents } from "@urp/alchemer";
import { Container } from "./styled-components";
import { Props } from "./types";

const ProfileNPPs = ({
  currentRace,
  entityRunnerId,
  runnerName,
  runnerDob,
  selectedRacePP,
  setSelectedRacePP,
  isMobile = false
}: Props) => {
  const [renderIpp, setRenderIpp] = useState(false);
  const wagerProfile = useWagerProfile();
  const originRaceConditions = {
    distance: currentRace.distance,
    surface: currentRace.surface?.shortName
  };

  const handleOnClick = () => {
    setRenderIpp(true);
    AlchemerEvents.selectMoreButton();
  };

  useEffect(() => {
    setRenderIpp(selectedRacePP >= 0);
  }, [selectedRacePP]);

  const handleCloseModal = () => {
    setRenderIpp(false);
    setSelectedRacePP(-1);
  };

  return (
    <Container isMobile={isMobile}>
      <Button
        qaLabel="see-profile-n-pps-button"
        variant="tertiary"
        icon="arrowRight"
        iconPosition="end"
        onPress={handleOnClick}
        isStretched={isMobile}
      >
        See Profile & PP&apos;s
      </Button>
      {renderIpp && (
        <div data-qa-label="profileNPPs-modal-wrapper">
          <ApolloContext.Consumer>
            {(clients: ApolloContextClients) => (
              <IPP
                runnerName={runnerName}
                runnerDob={runnerDob}
                entityRunnerId={entityRunnerId}
                originRaceCode={currentRace.track?.trackCode}
                originRaceNumber={currentRace.raceNumber}
                currentRace={currentRace}
                originRaceConditions={originRaceConditions}
                wagerProfile={wagerProfile}
                fcpClient={clients.fcpClient}
                behgClient={clients.behgClient}
                device={isMobile ? "mobile" : "tablet"}
                onModalClose={handleCloseModal}
                runners={currentRace.bettingInterests}
                raceTypeCode={currentRace.type?.code}
                selectedRacePP={selectedRacePP}
                isTvg5
              />
            )}
          </ApolloContext.Consumer>
        </div>
      )}
    </Container>
  );
};

export default ProfileNPPs;
